import { render, staticRenderFns } from "./NumberBullet.vue?vue&type=template&id=154c21f7"
import script from "./NumberBullet.vue?vue&type=script&lang=js"
export * from "./NumberBullet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports